module.exports = "<p>\n  {{'not-found.not.found'}}\n</p>\n"